import moment from 'moment';
import React from 'react';
import { Select } from '@gerdau/hefesto/Select';
import { TSelectOptionProps } from '@gerdau/hefesto/Select/Select.types';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { ICustomer } from '../../store/ducks/customers/types';
import {
  EFabricationContractsStatus,
  IFabricationContract
} from '../../store/ducks/fabrication-contracts/types';
import { uppercaseOnlyFirstLetter } from '../../utils/formatStrings';
import { Container } from './styles';

interface IFabricationContractsSelectProps {
  onChange(value: string): void;
  contracts: IFabricationContract[];
  contractNumber?: string;
  loading: boolean;
  hideLabel?: boolean;
  placeholder?: string;
  title?: string;
  showClosedContractMessage?: boolean;
  readOnly?: boolean;
}

const FabricationContractsSelect: React.FC<
  IFabricationContractsSelectProps
> = ({
  contractNumber,
  onChange,
  contracts,
  hideLabel = false,
  loading,
  showClosedContractMessage = false,
  readOnly
}) => {
  const customersState = useSelector(
    (appState: ApplicationState) => appState.customers
  );

  const getSoldToCustomer = (
    contract: IFabricationContract
  ): ICustomer | undefined => {
    return customersState.customers.find(
      (cust) => cust.customerId === contract.soldTo.code
    );
  };

  const getSelectedContract = () => {
    return contracts.find((contr) => contr.contractNumber === contractNumber);
  };

  const getContracts = (): TSelectOptionProps[] => {
    const contractsOptions = contracts.map((contract) => {
      const customer = getSoldToCustomer(contract);

      return {
        value: contract.contractNumber,
        label: `${contract.contractNumber} ${
          contract.customerOrder ? ` - ${contract.customerOrder}` : ''
        }`,
        descriptions: [
          contract.creationDate
            ? moment(contract.creationDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
            : '',
          customer
            ? `${uppercaseOnlyFirstLetter(customer.name)} - ${
                customer.customerId
              }`
            : ''
        ]
      };
    });

    return contractsOptions;
  };

  return (
    <Container
      readOnly
      data-testid="select-fabrication-construction-identification"
    >
      <Select
        name="contractsSelect"
        label={'Contrato da obra'}
        hideLabel={hideLabel}
        value={contractNumber}
        placeholder={`- Selecione -`}
        onSelect={(selectedValue: string | string[]) => {
          onChange(selectedValue as string);
        }}
        options={getContracts()}
        disabled={loading || readOnly}
        readOnly={readOnly}
        required
      ></Select>
      {contracts.length === 0 && !loading && (
        <span className="no-contracts">
          Não foram encontrados contratos disponíveis.
        </span>
      )}

      {showClosedContractMessage &&
        contracts.length > 0 &&
        !loading &&
        getSelectedContract()?.status ===
          EFabricationContractsStatus.CLOSED && (
          <span className="closed-contract">
            O contrato selecionado já foi encerrado.
          </span>
        )}
    </Container>
  );
};

export default FabricationContractsSelect;
